import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Alert, Spinner, Row, Col, Image, Button, Badge } from 'react-bootstrap';
import { LanguageProvider } from '../../core/language-provider';
import { DataManager } from '../../core/data-manager';
import { ResourceManager } from '../../core/resource-manager';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import courseHeaderDefault from '../../assets/course-header.jpg';
import CardCapitolo from '../../components/Card/Capitolo';
import CorsiInEvidenza from '../../components/CorsiInEvidenza';
import { settings } from '../../config/settings';
import { LoginManager } from '../../core/login-manager';
import FormPrenotazione from '../../components/Form';
import { toast } from 'react-toastify';
import { ApiManager } from '../../core/api-manager';
import { Utils } from '../../core/utils';




export default function Course() {

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const { k } = useParams();
    const id = parseInt(k)
    const [user, setUser] = useState(null);
    const [data, setData] = useState(null);
    const [granted, setGranted] = useState(false);
    const userInfo = LoginManager.getUserInfo();
    const [permission, setPermission] = useState(null);


    useEffect(() => {
        init()
    }, [id]);


    async function navigateCRM() {
        var temp = [];
        try {
            const response = await fetch('https://crm.fedespedi.it/api/elibrary-course/' + id, {
                headers: {
                    'API-KEY': 'hsR5Indj9L12vHb',
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) {
                throw new Error('Errore nella richiesta: ' + response.status);
            }
            const data = await response.json();
            console.log('Dati ricevuti:', data);
            window.open('https://crm.fedespedi.it/course/' + data.id, '_blank')


        } catch (error) {
            console.error('Errore: Il corso non è ancora disponibile');
            toast.error('Errore: Il corso non è ancora disponibile', { theme: 'colored' })
        }
    }


    async function init() {
        var res = await DataManager.getItem('user', userInfo.id);
        if (res.success === 1) {
            setUser(res.body[0]);
        }
        //----------------------------

        setPermission(null)
        console.log(granted)
        let constraintsGroup = [{
            "fieldName": "idUser",
            "type": "value",
            "value": userInfo.id
        },
        {
            "fieldName": "idCourse",
            "type": "in",
            "value": id
        }
        ];
        var sortingGroup = {
            'field': 'id',
            'order': 'desc'
        }
        var response = await DataManager.searchItems('course_user_active', 1, 1000, sortingGroup, '', [], constraintsGroup)
        var resCorso = await DataManager.getItem('course', id);
        var t = resCorso.body[0]
        console.log('AGAGAG', t)
        if ((response.success === 1 && response.body.length > 0)) {
            setData(t)
            setGranted(true)
        } else if ((response.success === 1 && response.body.length === 0) && (resCorso.success === 1 && resCorso.body[0].cost !== "")) {
            setGranted(false)
            setData(t)
        } else if ((response.success === 1 && response.body.length === 0) && (resCorso.success === 1 && resCorso.body[0].cost === "")) {
            setGranted(false)
            //setPermission('Non hai i permessi per accedere a questo corso! Contatta un amministratore.')
            setData(t)
        } else {
            setErrors(LanguageProvider.get('errors.get'))
            console.warn(response)
        }
        await getUserStats()

    }

    const [courseStats, setCourseStats] = useState(null);
    async function getUserStats() {
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var constraints = [
            {
                "fieldName": "idCourse",
                "type": "value",
                "value": id
            }
        ]
        var response = await DataManager.searchItems('gyv_course_user', 1, 1, sorting, '', [], constraints)
        if (response.success === 1 && response.body.length > 0) {
            console.warn('courseStats', response.body[0])
            setCourseStats(response.body[0])
        }
        else {
            console.warn(response)
        }
    }


    async function getCertificate(idCourse) {
        toast.info("Download in corso...", { theme: 'colored' })

        var constraints = [
            {
                "fieldName": "isCompleted",
                "type": "value",
                "value": 1
            },
            {
                "fieldName": "idCourse",
                "type": "value",
                "value": idCourse
            },
        ]
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var response = await DataManager.searchItems('gyv_course_user', 1, 1000, sorting, '', [], constraints)
        console.log(response);
        if (response.success === 1 && response.body.length > 0) {
            var resCourse = await DataManager.getItem('course', idCourse);
            if (resCourse.success === 1) {
                if (!Utils.isCourseEnded(resCourse.body[0].episodes)) {
                    toast.info('Il certificato sarà disponibile dal ' + Utils.getCertificateAvailableFrom(resCourse.body[0].episodes).format('DD/MM/YYYY'), { theme: 'colored' })
                    return
                }
                var courseDates = Utils.getCourseDates(resCourse.body[0].episodes)
                var sorting = {
                    'field': 'id',
                    'order': 'desc'
                }
                var constraints = [
                    {
                        "fieldName": "defaultTemplate",
                        "type": "value",
                        "value": 1
                    }
                ]
                var resFile = await DataManager.searchItems('certificate_template', 1, 100, sorting, '', [], constraints);
                console.log(resFile)
                if (resFile.success === 1) {
                    const body = {
                        idCourse: idCourse,
                        hash: resFile.body[0].file.hash,
                        name: userInfo.name,
                        surname: userInfo.surname,
                        nameCourse: resCourse.body[0].name,
                        notes: resCourse.body[0].certificateNotes,
                        episodes: resCourse.body[0].episodes,
                        numberEpisodes: resCourse.body[0].episodes.length,
                        date: moment().format('DD/MM/YYYY'),
                        hour: Math.ceil(response.body[0].total_episodes_time / 3600),
                        cf: user.cf || "",
                        episodesStart: courseDates.start ? courseDates.start.format('DD/MM/YYYY') : '',
                        episodesEnd: courseDates.end ? courseDates.end.format('DD/MM/YYYY') : '',
                    }

                    var responseWord = await ApiManager.sendAuthenticatedRequest('/public/get_certificate', body);
                    console.warn('CERTIFICATE', responseWord);
                    if (responseWord.success !== 1) {
                        toast.error(responseWord.message || 'Errore nella generazione del certificato', { theme: 'colored' })
                        return
                    }

                    var sorting = {
                        'field': 'id',
                        'order': 'desc'
                    }
                    var constraints = [
                        {
                            "fieldName": "hash",
                            "type": "value",
                            "value": responseWord.hash
                        }
                    ]
                    var res = await DataManager.searchItems('resource', 1, 100, sorting, '', [], constraints);
                    console.log(res)
                    if (res.success === 1) {
                        window.open(settings.ckdPath + 'upload/' + res.body[0].entity + '/' + res.body[0].filename)
                        /* setFile(res.body[0])
                        openModalFile() */
                    }


                }
            }
        }
    }



    if (permission !== null) {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {permission !== null &&
                    <>
                        <Alert variant='danger'>
                            {permission}
                        </Alert>
                        <Button onClick={() => { navigate('/') }}>Torna alla Home</Button>
                    </>

                }
            </Container>)
    }


    if (data) {
        console.log(data)
        if (data.name) {
            var image = data.image ? ResourceManager.getFileUrl(data.image, 'course') : courseHeaderDefault
            var hasCertificate = courseStats && courseStats.idCourse?.hasCertificate === 1
            var certificateReady = hasCertificate && Utils.isCourseEnded(data.episodes)
            return (
                <>
                    <Helmet>
                        <title>{data.name}</title>
                    </Helmet>

                    <Container fluid style={{ "backgroundImage": `url('${image}')` }} className='course-header-bg p-0'>
                        <div className='course-header-parent'>
                            <Container fluid='md' className=' mb-5 text-light course-header'>

                                {errors.length > 0 &&
                                    <Alert variant='danger'>
                                        {errors}
                                    </Alert>
                                }
                                <Button style={{ border: 0, color: 'white', backgroundColor: 'transparent' }} className='mb-5' onClick={() => navigate('/corsi')}><FontAwesomeIcon icon='arrow-left' className='me-2'></FontAwesomeIcon>{LanguageProvider.get('defaults.back')}</Button>
                                <h1>{data.name}</h1>
                                {/* <div className='lead' dangerouslySetInnerHTML={{ __html: data.description }}></div> */}
                                <p className='lead fw-bold'>{moment(data.date).format("YYYY")} - {data.episodes ? data.episodes.length : 0} {LanguageProvider.get('lms.episodes')}</p>
                                {data.topics && data.topics.map((topic, j) => {
                                    return (
                                        <span key={j} className='lead me-4 text-decoration-underline'>{topic.name}</span>
                                    )
                                })}
                            </Container>
                        </div>
                    </Container>


                    {courseStats && courseStats.isCompleted ? (
                        <Container>
                            <Container fluid='md' className='mt-5 mb-5 p-5' style={{ backgroundColor: 'var(--primary-color)', borderRadius: 20 }}>
                                <Row className='align-items-center'>
                                    <Col>
                                        <h3 className='text-white'>{certificateReady ? <><FontAwesomeIcon icon='certificate' className='me-2' /> Certificato disponibile</> : <><FontAwesomeIcon icon='certificate' className='me-2' /> Corso completato</>}</h3>
                                        <p className='lead text-white'>{certificateReady ? "Il tuo certificato di completamento del corso è disponibile al download." : hasCertificate ? "Complimenti! Hai completato il corso. Il certificato sarà disponibile dal " + Utils.getCertificateAvailableFrom(data.episodes).format('DD/MM/YYYY') + ", al termine dell'ultima lezione." : "Complimenti! Hai completato tutto il corso."}</p>
                                    </Col>
                                    {certificateReady ? <>
                                        <Button size='lg' variant='light' style={{ borderRadius: '20px' }} className='m-1' onClick={() => getCertificate(data.id)}>Scarica certificato</Button>
                                    </> : <></>}
                                </Row>
                            </Container>
                        </Container>
                    ) : null}


                    <Container fluid className='mt-5 mb-5'>
                        <Container fluid={'md'}>
                            <Row>
                                <Col md={4} xs={12}>
                                    {granted ? (
                                        <></>
                                    ) : (
                                        <Row className='align-items-center p-3 mb-3 text-white' style={{ backgroundColor: 'var(--primary-color)', borderRadius: '20px' }}>
                                            <Col md={12}>
                                                <h5><FontAwesomeIcon icon='users' className='me-2' /> {data.cost !== "" ? data.cost : "Gratuito"}</h5>
                                                <p>{data.paymentNotes}</p>
                                                <Button onClick={() => navigateCRM()} className='rounded-pill px-3' variant='light' style={{ color: 'var(--primary-color)' }}><FontAwesomeIcon icon='arrow-right-to-bracket' className='me-2'></FontAwesomeIcon>Invia richiesta</Button>
                                            </Col>
                                        </Row>
                                    )}
                                    {/* <Row className='align-items-center p-3 mb-3' style={{ backgroundColor: 'var(--secondary-color)', borderRadius: '20px', color: 'var(--primary-color)' }}>
                                        <Col md={1} xs={1}>
                                            <FontAwesomeIcon icon='chart-simple'></FontAwesomeIcon>
                                        </Col>
                                        <Col md={2} xs={1}>
                                            <h5 className='m-0'>{data.episodes.reduce((acc, cur) => acc + cur.points, 0)}</h5>
                                        </Col>
                                        <Col md={9} xs={9}>
                                            <h5 className='m-0'>eLearning Points</h5>
                                        </Col>
                                    </Row> */}
                                    <Row className='align-items-center p-3 mb-3' style={{ backgroundColor: 'var(--secondary-color)', borderRadius: '20px', color: 'var(--primary-color)' }}>
                                        <Col md={1} xs={1}>
                                            <FontAwesomeIcon icon='circle-play'></FontAwesomeIcon>
                                        </Col>
                                        <Col md={2} xs={1}>
                                            <h5 className='m-0'>{data.episodes && data.episodes.length}</h5>
                                        </Col>
                                        <Col md={9} xs={9}>
                                            <h5 className='m-0'>Lezioni</h5>
                                        </Col>
                                    </Row>
                                    <Row className='align-items-center p-3 mb-3' style={{ backgroundColor: 'var(--secondary-color)', borderRadius: '20px', color: 'var(--primary-color)' }}>
                                        <Col md={1} xs={1}>
                                            <FontAwesomeIcon icon='stopwatch'></FontAwesomeIcon>
                                        </Col>
                                        <Col md={2} xs={1}>
                                            <h5 className='m-0'>{data.estimatedTime}</h5>
                                        </Col>
                                        <Col md={9} xs={9}>
                                            <h5 className='m-0'>Durata ore</h5>
                                        </Col>
                                    </Row>
                                    <Row className='align-items-center p-3 mb-3' style={{ backgroundColor: '#f7f7f7', borderRadius: '20px', color: 'var(--primary-color)' }}>
                                        <Col xs={12}>
                                            <div dangerouslySetInnerHTML={{ __html: data.description }}></div>
                                            {/* <FontAwesomeIcon icon='share-nodes'></FontAwesomeIcon> */}
                                        </Col>
                                    </Row>
                                    {granted ? (
                                        <Row className='align-items-center p-3 mb-3' style={{ backgroundColor: '#f7f7f7', borderRadius: '20px', color: 'var(--primary-color)' }}>
                                            <Col xs={12}>
                                                <h5 className='mb-4'>Lista Materiali</h5>
                                                {data.documents && data.documents.map(item => {
                                                    var file_url = settings.ckdPath + "/upload/course_documents/" + item.file.hash + "." + item.file.extension
                                                    return (
                                                        <div key={item.id}>
                                                            <a href={file_url} target="_blank">
                                                                <Button variant='light' style={{ borderRadius: '20px', borderColor: 'var(--primary-color)', color: 'var(--primary-color)' }} className='px-3 mb-2 w-100'>{item.name}<FontAwesomeIcon icon='download' className='ms-2'></FontAwesomeIcon></Button>
                                                            </a>
                                                        </div>

                                                    )
                                                })}
                                            </Col>
                                        </Row>
                                    ) : null}
                                    {!granted && data.documents_notRegistered && data.documents_notRegistered.length > 0 && (
                                        <Row className='align-items-center p-3 mb-3' style={{ backgroundColor: '#f7f7f7', borderRadius: '20px', color: 'var(--primary-color)' }}>
                                            <Col xs={12}>
                                                <h5 className='mb-4'>Lista Materiali</h5>
                                                {data.documents_notRegistered.map(item => {
                                                    var file_url = settings.ckdPath + "/upload/course_documents_notRegistered/" + item.file.hash + "." + item.file.extension
                                                    return (
                                                        <div key={item.id}>
                                                            <a href={file_url} target="_blank">
                                                                <Button variant='light' style={{ borderRadius: '20px', borderColor: 'var(--primary-color)', color: 'var(--primary-color)' }} className='px-3 mb-2 w-100'>{item.name}<FontAwesomeIcon icon='download' className='ms-2'></FontAwesomeIcon></Button>
                                                            </a>
                                                        </div>
                                                    )
                                                })}
                                            </Col>
                                        </Row>
                                    )}

                                </Col>
                                <Col md={8} xs={12}>
                                    {data.episodes &&
                                        data.episodes
                                            .sort((a, b) => a.position - b.position)
                                            .map((episode, j) => {
                                                return (
                                                    <Container key={j} fluid className='px-md-4 rounded episode-preview'>
                                                        <CardCapitolo data={episode} courseGranted={granted}></CardCapitolo>
                                                    </Container>
                                                )
                                            })
                                    }

                                </Col>
                            </Row>


                        </Container>
                    </Container>

                    {granted ? (
                        <>
                        </>
                    ) : (
                        <>
                            <div id='formPrenotazione'>
                                <FormPrenotazione course={data.name}></FormPrenotazione>
                            </div>
                        </>
                    )}

                    <CorsiInEvidenza />

                </>
            )
        }
        else {
            return (
                <>
                    <Helmet>
                        <title>Corso non trovato</title>
                    </Helmet>

                    <Container fluid='md' className='mt-5 mb-5 text-secondary'>
                        <h3>Corso non trovato</h3>

                        {errors.length > 0 &&
                            <Alert variant='danger'>
                                {errors}
                            </Alert>
                        }

                    </Container>
                </>
            )
        }
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }
};